import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, FormsModule, UntypedFormControl } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { PopoverPositions, GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { MatButtonModule } from '@angular/material/button';
import { OverlayModule } from '@angular/cdk/overlay';
import { CrmFormButtonGroupComponent } from '../../form/modes/form-button-group.component';

@Component({
  selector: 'crm-model-driven-popover',
  templateUrl: './model-driven-popover.component.html',
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
    GalaxyFormFieldModule,
    GalaxyPopoverModule,
    MatButtonModule,
    OverlayModule,
    FormsModule,
    CrmFormButtonGroupComponent,
  ],
  providers: [],
  styleUrls: ['./model-driven-popover.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class CrmModelDrivenPopoverComponent implements OnInit {
  @Input({ required: true }) label: string;
  @Input({ required: true }) displayValue: string;
  @Input({ required: true }) control: UntypedFormControl;
  @Output() save = new EventEmitter<void>();

  renderedValue = '';
  openedPopover = false;
  popoverPositions = [PopoverPositions.Right, PopoverPositions.Bottom];

  openPopover(): void {
    this.openedPopover = true;
  }

  closePopover(): void {
    this.openedPopover = false;
  }

  saveModification(): void {
    if (this.control.invalid) {
      return;
    }
    this.renderedValue = this.displayValue ?? '';
    this.save.emit();
    this.closePopover();
  }

  ngOnInit(): void {
    this.renderedValue = this.displayValue ?? '';
  }
}
